import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  workItemHeader: {
    id: 'frontbucket.jswTab.siteIssuesList.workItemHeader',
    description:
      'Table header text for work item column in Site work items table',
    defaultMessage: 'Work item',
  },
  statusHeader: {
    id: 'frontbucket.jswTab.siteIssuesList.statusHeader',
    description: 'Table header text for status column in Site work items table',
    defaultMessage: 'Status',
  },
  assigneeHeader: {
    id: 'frontbucket.jswTab.siteIssuesList.assigneeHeader',
    description:
      'Table header text for assignee column in Site work items table',
    defaultMessage: 'Assignee',
  },
  updatedHeader: {
    id: 'frontbucket.jswTab.siteIssuesList.updatedHeader',
    description:
      'Table header text for updated column in Site work items table.  This is the last time the work item was updated',
    defaultMessage: 'Updated',
  },
  actionsHeader: {
    id: 'frontbucket.jswTab.siteIssuesList.actionsHeader',
    description:
      'Table header text for actions column in Site work items table',
    defaultMessage: 'Actions',
  },
  moreLabel: {
    id: 'frontbucket.jswTab.siteIssuesList.moreLabel',
    description: 'Label for "more" actions',
    defaultMessage: `More`,
  },
  createBranchButton: {
    id: 'frontbucket.jswTab.siteIssuesList.createBranchButton',
    description: 'Label for the "Create branch" action',
    defaultMessage: `Create branch`,
  },
  failedToLoadWorkItemsTitle: {
    id: 'frontbucket.jswTab.siteIssuesList.failedToLoadWorkItemsTitle',
    description: 'Work items failed to load message title',
    defaultMessage: `We can't load the work items`,
  },
  bitbucket: {
    id: 'frontbucket.dashboard.overview.jiraIssues.bitbucket',
    description:
      'Text for category of actions related to the Bitbucket product',
    defaultMessage: 'Bitbucket',
  },
  jira: {
    id: 'frontbucket.dashboard.overview.jiraIssues.jira',
    description: 'Text for category of actions related to the Jira product',
    defaultMessage: 'Jira',
  },
  copyWorkItemLink: {
    id: 'frontbucket.dashboard.overview.jiraIssues.copyWorkItemLink',
    description: 'Text for a button which copies a link to the Jira work item',
    defaultMessage: 'Copy work item link',
  },
  workItemLinkCopiedTitle: {
    id: 'frontbucket.dashboard.overview.jiraIssues.workItemLinkCopiedTitle',
    description: 'Title text for flag when copying work item link succeeds',
    defaultMessage: 'Work item link copied',
  },
  workItemLinkCopiedBody: {
    id: 'frontbucket.dashboard.overview.jiraIssues.workItemLinkCopiedBody',
    description: 'Body text for a flag when copying work item link succeeds',
    defaultMessage: 'Work item link successfully copied to your clipboard',
  },
  assignWorkItemSuccessTitle: {
    id: 'frontbucket.dashboard.overview.jiraIssues.assignWorkItemSuccessTitle',
    description: 'Title text for flag when assigning work item succeeds',
    defaultMessage: 'Work item assigned successfully',
  },
  assignWorkItemFailureTitle: {
    id: 'frontbucket.dashboard.overview.jiraIssues.assignWorkItemFailureTitle',
    description: 'Title text for flag when assigning work item fails',
    defaultMessage: 'Assigning the work item failed',
  },
  openInJira: {
    id: 'frontbucket.dashboard.overview.jiraIssues.openInJira',
    description: 'Text for a button which opens the work item in Jira',
    defaultMessage: 'Open in Jira',
  },
  assignToMe: {
    id: 'frontbucket.dashboard.overview.jiraIssues.assignToMe',
    description:
      'Text for a button which assigns the jira work item to the user clicking the button',
    defaultMessage: 'Assign to me',
  },
  viewMoreInJiraLink: {
    id: 'frontbucket.dashboard.overview.jiraIssues.viewMoreInJira',
    description:
      'Text for a link which redirect the user to Jira site and view more work items',
    defaultMessage: 'View more in Jira',
  },
});
